import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import {
  Heading,
  HorizontalRule,
  Panel,
  PlaybackList,
  PlaybackKey,
  PlaybackValue,
} from '@piggybank/core';

import { apiDateToDateObject, formatPercentage } from '~/utils';
import { formatAmount, formatAmountByValue, formatDateObj, setDepositInAccount } from '~/genericFunctions';
import { NLS } from '~/pages/PayrollReview/payrollReviewFunctions';

import { withAppContext } from '~/AppContext';

const TopUpOhcCreditInformationPanel = ({ data }) => {

  let index = 0;
  let existingLoan = get(data, 'displayData.loanOffer.existingLoan');
  let loanOptions = get(data, 'displayData.loanOffer.loanOptions');

  const principalAmount = isEmpty(loanOptions)? 0: get(loanOptions[index], 'principal.amount');
  const balanceAmount = isEmpty(existingLoan.balance)? 0: get(existingLoan, 'balance.amount');

  return (
    <Panel>
      <Heading level={2}>
        {NLS`Credit information`}
      </Heading>
      <PlaybackList>
        <PlaybackKey>{NLS`Amount of loan`}</PlaybackKey>
        <PlaybackValue type="large">{formatAmountByValue(principalAmount)}</PlaybackValue>

        <PlaybackKey>{NLS`Current credit balance to be settled`}</PlaybackKey>
        <PlaybackValue type="large">{formatAmountByValue(balanceAmount)}</PlaybackValue>

        <PlaybackKey>{NLS`Balance available in your account after paying off your current credit`}</PlaybackKey>
        <PlaybackValue type="large">{formatAmountByValue(setDepositInAccount(principalAmount, balanceAmount))}</PlaybackValue>

        <HorizontalRule marginBottom={4} />

        <PlaybackKey>{NLS`Term`}</PlaybackKey>
        <PlaybackValue>{loanOptions[index].term.length} {NLS`${loanOptions[index].term.timeUnit}`}</PlaybackValue>

        <PlaybackKey>{NLS`Frequency of payment`}</PlaybackKey>
        <PlaybackValue>{NLS`${loanOptions[index].payment.periodicity}`}</PlaybackValue>

        <PlaybackKey>{NLS`Payment amount`}</PlaybackKey>
        <PlaybackValue>{formatAmount(loanOptions, index, 'payment.amount.amount')}</PlaybackValue>

        <PlaybackKey>{NLS`First payment date`}</PlaybackKey>
        <PlaybackValue>{formatDateObj(apiDateToDateObject(loanOptions[index].payment.firstPaymentDate))}</PlaybackValue>

        <PlaybackKey>{NLS`Annual fixed interest rate`}</PlaybackKey>
        <PlaybackValue><strong>{loanOptions[index].interestRate}%</strong></PlaybackValue>

        <PlaybackKey>{NLS`CAT`}</PlaybackKey>
        <PlaybackValue><strong>{`${formatPercentage(loanOptions[index].totalAnnualCostPercentage, 1)} ${NLS`withoutVAT`}`}</strong></PlaybackValue>

        <PlaybackKey>{NLS`Date of CAT calculation`}</PlaybackKey>
        <PlaybackValue>{formatDateObj(apiDateToDateObject(loanOptions[index].totalAnnualCostCalculationDate))}</PlaybackValue>

        <PlaybackKey>{NLS`Validity of the offer`}</PlaybackKey>
        <PlaybackValue>{formatDateObj(apiDateToDateObject(loanOptions[index].offerExpiryDate))}</PlaybackValue>

        <PlaybackKey>{NLS`Commission fee`}</PlaybackKey>
        <PlaybackValue>{formatAmount(loanOptions, index, 'fees.commission.amount')}</PlaybackValue>

        <PlaybackKey>{NLS`Value added tax`}</PlaybackKey>
        <PlaybackValue marginBottom={0}>{formatAmount(loanOptions, index, 'fees.valueAddedTax.amount')}</PlaybackValue>
      </PlaybackList>
    </Panel>
  );
};

TopUpOhcCreditInformationPanel.propTypes = {
  data: PropTypes.shape({
    displayData: PropTypes.shape({
      loanOffer: PropTypes.shape({
        existingLoan: PropTypes.object,
        loanOptions: PropTypes.arrayOf(PropTypes.shape()),
      }),
    }),
  }),
};

export default withAppContext()(TopUpOhcCreditInformationPanel);
